export const EaseIn = () => {
  return "animateAppearance .75s easeOut";
};